import { Contact } from '@/modules/content-blocks/interfaces';

export const createDefaultContact = (): Contact => ({
   id: crypto.randomUUID(),
   image: {
      alt_text: null,
      id: null,
      url: null,
      name: null,
   },
   name: null,
   phone: null,
   email: null,
});
